import {useEffect, useState} from 'react'

import SynthesisVoicesPlayer from './SynthesisVoicesPlayer'
import OverallProgress from '../OverallProgress'
import {trl, trlObject} from '~/services/intl'
import {showErrorPopup} from '~/services/popup'
import {getDemoVoices} from '~/services/synthesis'

import type {Voice} from '~/services/synthesis'

export default function SynthesisVoices() {
    const [ready, setReady] = useState(true)
    const [activeVoice, setActiveVoice] = useState('')
    const [voices, setVoices] = useState<Voice[]>([])
    const languageMap: {[Key in string]?: string} = trlObject('_languages')

    useEffect(() => {
        setReady(false)

        getDemoVoices()
            .then(setVoices)
            .then(() => setReady(true))
            .catch(showErrorPopup)
    }, [])

    return <div className='documentation__text'>
        <div className='documentation__text-wrapper'>
            <div className='documentation__content'>
                <div className='documentation__text-content'>
                    <h1>{trl('Синтез речи')}</h1>
                    <h2>{trl('Список голосов')}</h2>
                    {ready
                        ? <table>
                            <thead>
                                <tr>
                                    <th>
                                        <b>{trl('Язык')}</b>
                                    </th>
                                    <th>
                                        <b>{trl('Голос')}</b>
                                    </th>
                                    {/* <th>
                                        <b>{trl('Пол')}</b>
                                    </th> */}
                                    <th>
                                        <b>{trl('Пример голоса')}</b>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {voices.map(({id, name, languages}) => <tr key={id}>
                                    <td>{languageMap[languages[0]] || languages[0]}</td>
                                    <td>{name}</td>
                                    {/* <td>{voice.gender}</td> */}
                                    <td>
                                        <SynthesisVoicesPlayer
                                            voiceId={id}
                                            language={languages[0]}
                                            activeVoice={activeVoice}
                                            setActiveVoice={setActiveVoice}
                                        />
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                        : <OverallProgress/>
                    }
                </div>
            </div>
        </div>
    </div>
}
